import { usePageAction } from '@repo/hooks/usePageAction';
import { useState } from 'react';
import type { TableOfContentsHeadingProps } from './types';

type Props = {
  headings: TableOfContentsHeadingProps[];
};

export const useTableOfContents = ({ headings }: Props) => {
  const [activeId, setActiveId] = useState<string>(headings[0].id);

  const fireNavigateToSectionPageAction = usePageAction({
    actionName: 'toc_interacted',
    actionSection: 'table_of_contents',
    actionType: 'navigate',
  });

  return {
    activeId,
    setActiveId,
    fireNavigateToSectionPageAction,
  };
};
